import app, { Component } from 'apprun';
import { isValidElement, showSaveStatusMessage, } from '../utils';
import { ProtectionRoyale } from '../api';
import moment from 'moment';
export default class CommonPropertyComponent extends Component {
  dateFmt = 'DD-MMM-YYYY';

  state = { progs: [] };

  cleanState = {
    prSubsStartDatePicker: null,
    prSubsEndDatePicker: null,
    editingItem: null,
    prSubsSaveError: null,
  };

  Item = ({ item, editingProgId }) => {
    return (
      <tr
        style={{ display: 'table-row' }}
        onclick={
          !item.locked
            ? (e) => {
              this.run('prSubs-edit', item, e);
            }
            : ''
        }>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.activeInd ? 'Active' : 'Inactive'}
          </span>
        </td>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.startDate ? moment.utc(item.startDate).format(this.dateFmt) : ''}
          </span>
        </td>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.endDate ? moment.utc(item.endDate).format(this.dateFmt) : ''}
          </span>
        </td>
        <td>
          <div class="col-sm-2 text-right">
            {item.locked ? <i class="fa fa-lock" /> : ''}
            {item.id === editingProgId ? <i class="control-label glyphicon glyphicon-pencil" /> : ''}
          </div>
        </td>
      </tr>
    );
  };

  List = ({ state }) => {
    return (
      <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover">
        <thead>
          <tr>
            <th>Status</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {state.progs.map(item => (
            <this.Item item={item} editingProgId={state.editingProgId} />
          ))}
        </tbody>
      </table>
    );
  };

  PRSubsHistory = ({ state }) => {
    return (
      <div>
        <div class="col-sm-12">Protection Royale Subscription(s)</div>
        <div style={{ 'white-space': 'normal', 'word-wrap': 'break-word' }}>
          <this.List state={state} />
        </div>
      </div>
    );
  };

  CommProgEdit = ({ state }) => {
    return (
      <div style={{ display: state.editingProg ? 'disp' : 'none' }}>
        <div class="row">
          <label class="col-sm-5">Start Date</label>
          <label class="col-sm-5">End Date</label>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <input $pikaday autocomplete="off" id="prSubsStartDate" size="62" class="form-control" value={state.prSubsStartDate} />
          </div>
          <div class="col-sm-5">
            <input $pikaday autocomplete="off" id="prSubsEndDate" size="62" class="form-control" value={state.prSubsEndDate} />
          </div>
        </div>
        <div class="row">
          <div id="prSubsStartDateErrMsg" class="text-danger, col-sm-5"></div>
          <div id="prSubsEndDateErrMsg" class="text-danger, col-sm-5"></div>
          <div id="prSubsReturnedErrMsg" class="text-danger, col-sm-5">
            {state.prSubsSaveError}
          </div>
        </div>
        <br></br>

        <div class="edit-buttons">
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('prSubs-edit-save')}>
            save
          </a>
          <a type="button" class="btn btn-default btn-xs" onclick={() => this.run('prSubs-edit-cancel')}>
            cancel
          </a>
        </div>
      </div>
    );
  };

  // prettier-ignore
  view = (state) => {
    return (
      <div style={{ width: '550px' }}>
        <this.PRSubsHistory state={state} />
        <div class="edit-buttons">
          <a type="button" class="btn btn-default btn-xs" onclick={() => state.caller.run(state.cancel, state.panelId)}>
            exit
          </a>
        </div>
        <br/>
        <this.CommProgEdit state={state} />
        <br/><br/>
      </div>
    );
  };

  update = {
    refresh: async (state, newState) => {
      if (newState.panelId !== state.personId) {
        state = this.cleanState;
        state.personId = newState.personId;
      }
      state.progs = await ProtectionRoyale.get(state.personId);
      return { ...state, ...newState };
    },

    'prSubs-edit': async (state, item) => {
      if (state.editingProg) {return;}

      state.prSubsStartDate = item.startDate ? moment.utc(item.startDate).format(this.dateFmt) : '';
      state.prSubsEndDate = item.endDate ? moment.utc(item.endDate).format(this.dateFmt) : '';

      state.editingProg = true;
      state.editingProgId = item.id;
      state.progUnderEdit = item;
      return state;
    },

    'prSubs-edit-save': async (state) => {
      state.prSubsSaveError = null;
      const prSubsReturnedErrMsgDiv = document.getElementById('prSubsReturnedErrMsg') as HTMLDivElement;
      prSubsReturnedErrMsgDiv.innerHTML = state.prSubsSaveError;

      state.prSubsStartDate = (document.getElementById('prSubsStartDate') as HTMLInputElement).value.trim();
      state.prSubsEndDate = (document.getElementById('prSubsEndDate') as HTMLInputElement).value.trim();

      let valid = isValidElement('prSubsStartDate', 'DateStr');
      if (state.prSubsEndDate) {
        valid = valid && isValidElement('prSubsEndDate', 'DateStr');
        if (valid && moment(state.prSubsStartDate, this.dateFmt) > moment(state.prSubsEndDate, this.dateFmt)) {
          valid = false;
          const errMsg = document.getElementById('prSubsEndDateErrMsg') as HTMLDivElement;
          errMsg.innerHTML = 'End date cannot be before Start date';
        }
      }

      if (valid) {
        const progToSave =
          state.editingProgId === 0
            ? { id: 0, commercialFeeID: state.commercialProgFeeID, startDate: state.prSubsStartDate, endDate: state.prSubsEndDate }
            : { ...state.progUnderEdit, startDate: state.prSubsStartDate, endDate: state.prSubsEndDate };
        let result;
        try {
          result = await ProtectionRoyale.upsertPRSubs(state.personId, progToSave);
          showSaveStatusMessage(result===1?'Success: ' : result);
        } catch (ex) {
          showSaveStatusMessage();
          const errorMsg = await ex.json();
          state.prSubsSaveError = '* ' + errorMsg;
          return state;
        }

        if (result) {
          state.progs = await ProtectionRoyale.get(state.personId);
          this.run('prSubs-edit-cancel');
        }
      }
    },

    'prSubs-edit-cancel': (state) => {
      state.editingProg = false;
      state.progUnderEdit = null;
      state.editingProgId = null;
      return state;
    },
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
